
import React from 'react';
import './i18n.js';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import store from './store/store.js'; // Assuming you've exported your Redux store from a file named store.js

import App from './App';

const root = document.getElementById('root');

const rootElement = createRoot(root);
rootElement.render(
  <Provider store={store}>
    <App />
  </Provider>
);
